import React, { useMemo } from 'react';
import { motion } from 'motion/react';
import HomePreview from '../section/HomePreview';
import PageTransition from '../components/PageTransition';
import { fadeUp, fadeLeft, fadeRight, staggerContainer, scaleFade, viewport } from '../components/useScrollAnimation';
import '../style.css';

const HomePage = () => {

  const experienceYears = useMemo(() => {
    const startYear = new Date(2010, 2, 1);
    const today = new Date();

    let years = today.getFullYear() - startYear.getFullYear();
    const anniversary = new Date(
      today.getFullYear(),
      startYear.getMonth(),
      startYear.getDate()
    );

    if (today < anniversary) {
      years -= 1;
    }

    return years;
  }, []);

  const stats = [
    { value: `${experienceYears}+`, label: 'Tahun Pengalaman' },
    { value: '1000+', label: 'Students Berprogres' },
    { value: '3+', label: 'Partner Hotel' },
    // { value: '6', label: 'Negara Destinasi' },
  ];

  return (
    <PageTransition>
      {/* ── HERO ── */}
      <section className="home-hero">
        <div className="home-hero-overlay" />
        <div className="home-hero-bg-pattern" />
        <div className="container home-hero-content">

          {/* Eyebrow badges — fade in from left */}
          <motion.div
            className="home-hero-eyebrow"
            variants={fadeLeft}
            initial="hidden"
            animate="show"
          >
            <span className="home-badge">NIEC Indonesia</span>
            <span className="home-badge home-badge-outline">Since 2010</span>
          </motion.div>

          {/* Headline — fade up with slight delay */}
          <motion.h1
            className="home-hero-headline"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            transition={{ delay: 0.15 }}
          >
            International Internship<br />
            <span className="home-hero-highlight">Pathway Program</span>
            <div className="home-hero-headline-sub">
              Gerbangmu Menuju Karier Internasional
            </div>
          </motion.h1>

          {/* Sub-paragraph */}
          <motion.p
            className="home-hero-sub"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            transition={{ delay: 0.28 }}
          >
            Lebih dari 1000 students telah berprogres di luar negeri bersama NIEC Indonesia.
            Pilih program yang tepat dan mulai perjalananmu sekarang.
          </motion.p>

          {/* CTA buttons — stagger */}
          <motion.div
            className="home-hero-cta"
            variants={staggerContainer(0.14, 0.4)}
            initial="hidden"
            animate="show"
          >
            <motion.a
              href="https://wa.me/6281138914770"
              target="_blank"
              rel="noreferrer"
              className="home-btn-primary"
              variants={fadeUp}
            >
              <i className="fa-brands fa-whatsapp" /> Konsultasi Gratis
            </motion.a>
            <motion.a
              href="#programs"
              className="home-btn-ghost"
              variants={fadeUp}
            >
              Lihat Program <i className="fa-solid fa-chevron-down" />
            </motion.a>
          </motion.div>
        </div>

        {/* Stats bar — stagger each stat */}
        <motion.div
          className="home-stats-bar"
          variants={staggerContainer(0.15, 0.55)}
          initial="hidden"
          animate="show"
        >
          <div className="container home-stats-inner">
            {stats.map((s, i) => (
              <motion.div key={i} className="home-stat-item" variants={scaleFade}>
                <span className="home-stat-value">{s.value}</span>
                <span className="home-stat-label">{s.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* ── PROGRAM PREVIEW CARDS ── */}
      <div id="programs">
        <HomePreview />
      </div>
    </PageTransition>
  );
};

export default HomePage;
